import Cookies from 'js-cookie';
export var toggleLanguage = function toggleLanguage(language) {
  var config = getCookieConfig();
  Cookies.remove('user_language', config);
  if (language === 'FR') {
    Cookies.set('user_language', 'fr', config);
  } else if (language === 'EN') {
    Cookies.set('user_language', 'en', config);
  }
  location.reload();
};
var originContainsString = function originContainsString(target) {
  var _window, _window$location, _window$location$orig;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$orig = _window$location.origin) === null || _window$location$orig === void 0 ? void 0 : _window$location$orig.indexOf(target)) !== -1;
};
var getCookieConfig = function getCookieConfig() {
  return {
    path: '/',
    domain: originContainsString('localhost') ? 'localhost' : '.carfax.ca'
  };
};
export var getOpenNewTabProps = function getOpenNewTabProps(openInNewTab) {
  return openInNewTab ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {
    target: '_self',
    rel: ''
  };
};